import React from 'react'
import HeadingForm from '../elements/HeadingForm'
import OrderHisItem from './OrderHisItem'

const OrderHistory = () => {
    return (
        <div className="order-history flex-1 container py-4">
            <HeadingForm>Đơn hàng của tôi</HeadingForm>

            <div className="order-history__list mt-8">
                <OrderHisItem />
                <OrderHisItem />
                <OrderHisItem />
                <OrderHisItem />
            </div>
        </div>
    )
}

export default OrderHistory
